import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Column, Cell } from 'fixed-data-table-2';
import 'fixed-data-table-2/dist/fixed-data-table.css';
// import './Css/Grid.css'
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import * as Files from './Saga/Files';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { Modal, ModalFooter, ModalBody } from 'reactstrap';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import GetAppIcon from '@mui/icons-material/GetApp';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import DescriptionIcon from '@mui/icons-material/Description';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import Select from '@mui/material/Select';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import BackupIcon from '@mui/icons-material/Backup';
import Tooltip from '@mui/material/Tooltip';


var moment = require('moment-timezone');

const Base = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >
    {props.contract_files[rowIndex][column.key]}
  </Cell>;

const PName = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap", width: "100%", height: "100%",borderTop: "1px solid  #DDDDDD", backgroundColor:props.contract_files[rowIndex].status == 3 ? "#72C6EF" : props.contract_files[rowIndex].status == 2 ? '#ffc9d2' : '' }} >
    <IconButton style={{marginTop:-5}} onClick={(e) => { props.download_contract_files(props.contract_files[rowIndex]) }} aria-label="edit" size="small">
      <GetAppIcon />
    </IconButton>
  </Cell>;

const Name = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap", width: "100%", height: "100%",borderTop: "1px solid  #DDDDDD", backgroundColor:props.contract_files[rowIndex].status == 3 ? "#72C6EF" : props.contract_files[rowIndex].status == 2 ? '#ffc9d2' : '' }} >
    {props.contract_files[rowIndex].type == 1 && props.contract_files[rowIndex].status === 1 ? "賃貸借契約書" : props.contract_files[rowIndex][column.key]}
  </Cell>;

const Icon = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap", width: "100%", height: "100%", borderTop: "1px solid  #DDDDDD", backgroundColor:props.contract_files[rowIndex].status == 3 ? "#72C6EF" : props.contract_files[rowIndex].status == 2 ? '#ffc9d2' : '', textAlign:'center' }} >
    {/* {props.contract_files[rowIndex].type == 1 ? <DescriptionIcon fontSize="small" /> : <AttachFileIcon fontSize="small" />} */}
    { props.contract_files[rowIndex].status == 3 ? <Tooltip title={<h6 style={{margin:0,paddin:0}}>署名完了</h6>}><CloudDoneIcon sx={{ color: '#223a70' }}/></Tooltip> : props.contract_files[rowIndex].status == 2 ? <Tooltip title={<h6 style={{margin:0,paddin:0}}>契約書送信</h6>}><BackupIcon sx={{ color: '#d7003a' }}/></Tooltip> : props.contract_files[rowIndex].type == 1 ? <DescriptionIcon fontSize="small" /> : <AttachFileIcon fontSize="small" />}
  </Cell>;

const CreatedAt = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap", width: "100%", height: "100%",borderTop: "1px solid  #DDDDDD", backgroundColor:props.contract_files[rowIndex].status == 3 ? "#72C6EF" : props.contract_files[rowIndex].status == 2 ? '#ffc9d2' : '' }} >
    {moment(props.contract_files[rowIndex][column.key]).format('YYYY-MM-DD HH:mm:ss')}
  </Cell>;

const Edit = ({ column, props, rowIndex, file_remarks_edit_open }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >
    {props.contract_files[rowIndex].type == 0 ? 
    <IconButton style={{marginTop:-5}} onClick={(e)=>{file_remarks_edit_open({ fileid: props.contract_files[rowIndex].id, name: props.contract_files[rowIndex].name, remarks: props.contract_files[rowIndex].remarks ? props.contract_files[rowIndex].remarks : "" }) }} aria-label="edit" size="small">
      <EditIcon />
    </IconButton>:""}
  </Cell>;

const Delete = ({ column, props, rowIndex, fncdelete, is_delete }) =>
  <Cell style={{ whiteSpace: "nowrap", width: "100%", height: "100%",borderTop: "1px solid  #DDDDDD", backgroundColor:props.contract_files[rowIndex].status == 3 ? "#72C6EF" : props.contract_files[rowIndex].status == 2 ? '#ffc9d2' : '' }} >
    {props.contract_files[rowIndex].type == 0 ? 
    <IconButton style={{marginTop:-5}} onClick={(e)=>fncdelete(is_delete, props.contract_files[rowIndex].id) } aria-label="edit" size="small">
      <DeleteIcon />
    </IconButton>:""}
  </Cell>;

const files = ['pdf', 'png', 'jpg', 'jpeg', 'bmp', 'gif', 'JPG'];

const Disp = ({ column, props, rowIndex, openWindow }) =>
  <Cell style={{ whiteSpace: "nowrap", width: "100%", height: "100%",borderTop: "1px solid  #DDDDDD", backgroundColor:props.contract_files[rowIndex].status == 3 ? "#72C6EF" : props.contract_files[rowIndex].status == 2 ? '#ffc9d2' : '' }} >
    {props.contract_files[rowIndex].extension && files.includes(props.contract_files[rowIndex].extension.trim()) && props.contract_files[rowIndex].status !== 1 ? 
    <span>
      <Button variant="contained" style={{}} size="small" onClick={() => props.download_disp_contract_files(props.contract_files[rowIndex])} color="primary">表示</Button>
      <IconButton size="small" onClick={() => openWindow(props.contract_files[rowIndex].id)} color="primary">
        <OpenInNewIcon />
      </IconButton>
    </span>:""}
    {/* <Button variant="contained" style={{}} size="small" onClick={() => props.download_disp_contract_files(props.contract_files[rowIndex])} color="primary">表示</Button> */}
  </Cell >;


const Amount = ({ column, props, rowIndex, monies }) =>
  monies[rowIndex].name === "合計" ? <Cell style={{ whiteSpace: "nowrap", background: "#f0f8ff", width: "100%", height: "100%" }} >{monies[rowIndex][column.key]}</Cell> : monies[rowIndex].rent_m_etc_id ? <Cell style={{ whiteSpace: "nowrap", background: "#CCC", width: "100%", height: "100%" }} /> : <Cell style={{ whiteSpace: "nowrap" }} >
    <TextField
      id="outlined-basic"
      //   className={classes.textField}
      label=""
      margin="normal"
      name="tatemono_name"
      // onChange={this.handleChange}
      inputProps={{ min: 0, style: { textAlign: 'right' } }} // the change is here
      value={monies[rowIndex][column.key]}
      style={{ width: "70px", marginTop: 0 }}

    />

  </Cell>;
const all_seikyuu = [
  { value: -1, name: "請求" },
  { value: 1, name: "定額" },
  { value: 2, name: "実費" },
  { value: 3, name: "込み" }
]
const koushin_seikyuu = [
  { value: -1, name: "請求" },
  { value: 3, name: "無し" }
]
const seisan_seikyuu = [
  { value: 1, name: "実費" },
  { value: 2, name: "込み" }
]
const Seikyuu = ({ column, props, rowIndex, monies }) =>
  monies[rowIndex].name === "合計" ? <Cell style={{ whiteSpace: "nowrap", background: "#f0f8ff", width: "100%", height: "100%" }} /> : <Cell style={{ whiteSpace: "nowrap" }} >
    <Select
      labelId="demo-simple-select-label"
      id="demo-simple-select"
      value={monies[rowIndex].rent_m_etc_id ? monies[rowIndex].rent_m_etc_id : -1}
    // defaultValue={0}
    // onChange={handleChange}
    >
      {monies[rowIndex].account_group === 3 ? koushin_seikyuu.map(function (value) {
        return <MenuItem value={value.value}>{value.name}</MenuItem>
      }) : monies[rowIndex].rent_m_account_id === 17 ? seisan_seikyuu.map(function (value) {
        return <MenuItem value={value.value}>{value.name}</MenuItem>
      }) : all_seikyuu.map(function (value) {
        return <MenuItem value={value.value}>{value.name}</MenuItem>
      })}


    </Select>
  </Cell>;




var SortTypes = {
  ASC: 'ASC',
  DESC: 'DESC',
};


function reverseSortDirection(sortDir) {
  return sortDir === SortTypes.DESC ? SortTypes.ASC : SortTypes.DESC;
}
class SortHeaderCell extends React.Component {
  constructor(props) {
    super(props);

    this._onSortChange = this._onSortChange.bind(this);
  }

  render() {
    var { onSortChange, sortDir, children, ...props } = this.props;
    return (
      <Cell {...props} onClick={this._onSortChange}>

        {children} {sortDir ? (sortDir === SortTypes.DESC ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />) : ''}

      </Cell>
    );
  }

  _onSortChange(e) {

    e.preventDefault();

    if (this.props.onSortChange) {
      this.props.onSortChange(
        this.props.columnKey,
        this.props.sortDir ?
          reverseSortDirection(this.props.sortDir) :
          SortTypes.DESC
      );
    }
  }
}


const columns = [
  { key: 'p_name', name: 'DL', width: 50 },
  { key: 'icon', name: '状態', width: 50 },
  {
    key: 'name', name: 'ファイル名', width: 200,

  },
  // { key: 'remarks', name: '備考', width: 150 },
  { key: 'disp', name: '表示', width: 100 },
  // { key: 'edit', name: '編集', width: 60 },
  { key: 'delete', name: '削除', width: 60 },
  { key: 'created_at', name: 'アップロード日時', width: 150 },



]







class CustomerList extends Component {
  constructor(props) {
    super(props);


    // this.props.rent_m_contract_follows_disp.map(async function (value) {
    //   if (value.disp) {
    //     columns.push({ key: value.key_name, name: value.name, company: value.company, width: 80 })
    //   }
    // })
    console.log(columns)

    this.state = {
      columns: columns,
      reflesh: false,
      modalreserve: false,
      cardx: window.innerWidth - 600,
      colSortDirs: {},
      is_delete : false,
      delete_id : 0,
      // dataList: new FakeObjectDataListStore(1000000),
      // columnWidths: {
      //   firstName: 240,
      //   lastName: 150,
      //   sentence: 140,
      //   companyName: 60,
      // },
    };
    // this.props.get_contract_follow_list()
    this._onColumnResizeEndCallback = this._onColumnResizeEndCallback.bind(this);
    this.delete = this.delete.bind(this);


    // this.contractdetail = this.contractdetail.bind(this);


  }





  _onColumnResizeEndCallback(newColumnWidth, columnKey) {

    let columnsset = this.state.columns.map(function (value) {
      if (value.key === columnKey) {
        value.width = newColumnWidth
      }
      return value
    })

    this.setState({ columns: columnsset })

  }

  delete(is_delete, id){
    this.setState({
      delete_id: id,
      is_delete: !is_delete
    });
  }








  openWindow(id){
    window.open(`/FileDisp/` + '4/' + id, '_blank', 'noopener,width=500,toolbar=yes,menubar=yes,scrollbars=yes')
  }


  render() {

    return (
      <div id="contract_car" >





        {
          this.props.contract_files ? <div style={{ marginBottom: 10 }}><Table
            rowHeight={40}
            rowsCount={this.props.contract_files.length}
            onColumnResizeEndCallback={this._onColumnResizeEndCallback}
            isColumnResizing={false}
            touchScrollEnabled={true}
            // width="100%"
            // height={this.props.contract_files.length * 40 + 42}
            // width={window.innerWidth - 110}
            // height={window.innerHeight - 250}
            width={(window.innerWidth / 2) - 75}
            height={350}
            headerHeight={40}>
            {this.state.columns.map(function (value, i) {
              return <Column
                columnKey={value.key}
                header={<SortHeaderCell
                  onSortChange={this._onSortChange}
                  sortDir={this.state.colSortDirs[value.key]}
                  style={{ whiteSpace: "nowrap" }}>{value.name}</SortHeaderCell>}

                // cell={({ rowIndex, ...props }) => (<Cell style={{ whiteSpace: "nowrap" }} >{this.props.seisan_follow_list[rowIndex][value.key]}</Cell>)}
                cell={({ rowIndex, ...props }) => (

                  value.key === "disp" ? <Disp column={value} props={this.props} rowIndex={rowIndex} openWindow={this.openWindow}></Disp>
                    //   : value.key === "rent_m_etc_id" ? <Seikyuu column={value} props={this.props} rowIndex={rowIndex} monies={hiwari}></Seikyuu>

                    //     : value.key === "amount" ? <Amount column={value} props={this.props} rowIndex={rowIndex} monies={hiwari}></Amount>
                    //       : value.key === "delete" ? <Delete column={value} props={this.props} rowIndex={rowIndex} monies={hiwari}></Delete>
                    : value.key === "icon" ? <Icon column={value} props={this.props} rowIndex={rowIndex} ></Icon>
                    : value.key === "name" ? <Name column={value} props={this.props} rowIndex={rowIndex} ></Name>
                    : value.key === "p_name" ? <PName column={value} props={this.props} rowIndex={rowIndex} ></PName>
                    : value.key === "created_at" ? <CreatedAt column={value} props={this.props} rowIndex={rowIndex} ></CreatedAt>
                    : value.key === "edit" ? <Edit column={value} props={this.props} rowIndex={rowIndex} file_remarks_edit_open={this.props.file_remarks_edit_open} ></Edit>
                    : value.key === "delete" ? <Delete column={value} props={this.props} rowIndex={rowIndex} fncdelete={this.delete} is_delete={this.state.is_delete} ></Delete>
                    :<Base column={value} props={this.props} rowIndex={rowIndex} ></Base>

                )}

                width={value.width}
                isResizable={true}


              />
            }, this)}

          </Table > </div> : ""
        }

                <Modal isOpen={this.state.is_delete} toggle={()=>this.delete(this.state.is_delete, 0)} fade={false} className="modal-dialog-centered">
                    <ModalBody>
                        <div>本当に削除してよろしいですか？</div>
                    </ModalBody>
                    <ModalFooter>
                        <Button variant="contained" color="secondary" onClick={()=>{this.props.delete_contract_file(this.state.delete_id);this.delete(this.state.is_delete, 0)}}>削除</Button>
                        <Button variant="contained" style={{marginLeft:3}} onClick={()=>this.delete(this.state.is_delete, 0)}>閉じる</Button>
                    </ModalFooter>
                        
                </Modal>


      </div >
    );
  }
};


//export  default CustomerList;
const mapStateToProps = (state) => {
  return {
    section_select: state.masterReducer.section_select,
    // search_modal: state.Adjustment.search_modal,
    user_details: state.masterReducer.user_details,
    users_select: state.masterReducer.users_select,
    contract_files: state.files.contract_files,

  }
}
function mapDispatchToProps(dispatch) {
  return {



    download_disp_contract_files(state) {
      dispatch(Files.download_disp_contract_files(state))
    },

    download_contract_files(state) {
      dispatch(Files.download_contract_files(state))
    },
    change_contract_file_update_disp(state) {
      dispatch(Files.change_contract_file_update_disp(state))
    },
    delete_contract_file(state) {
      dispatch(Files.delete_contract_file(state))
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerList);